export interface ClonePlanRequest {
    id: string;
    name: string;
}